import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  handleTranscribeAudio,
  transcribingAudio = false,
  handleTranslateMessage,
  translatingMessage = false,
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [showTranslateLanguages, setShowTranslateLanguages] = useState(false);

  const translateLanguages = [
    { language: "en", label: "Inglés" },
    { language: "pt", label: "Portugués" },
    { language: "fr", label: "Francés" },
    { language: "es", label: "Español" },
    { language: "he", label: "Hebreo" },
  ];

  const canTranslateMessage = Boolean(
    !message.isDeleted &&
      !message.mediaUrl &&
      !message.internalNote &&
      String(message.body || "").trim()
  );

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleCloseMenus = () => {
    setShowTranslateLanguages(false);
    handleClose();
  };

  const handleSelectTranslateLanguage = (language) => {
    setShowTranslateLanguages(false);
    handleClose();
    handleTranslateMessage(message, language);
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <Menu
        anchorReference="anchorPosition"
        anchorPosition={anchorEl}
        getContentAnchorEl={null}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleCloseMenus}
      >
        {message.fromMe && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        {message.mediaType === "audio" && !message.isDeleted && (
          <MenuItem
            disabled={transcribingAudio}
            onClick={() => handleTranscribeAudio(message)}
          >
            {transcribingAudio ? "Transcribiendo audio..." : "Transcribir audio"}
          </MenuItem>
        )}
        {canTranslateMessage && (
          <MenuItem
            disabled={translatingMessage}
            onClick={() => setShowTranslateLanguages(current => !current)}
          >
            {translatingMessage ? "Traduciendo..." : "Traducir mensaje"}
          </MenuItem>
        )}
        {canTranslateMessage &&
          showTranslateLanguages &&
          translateLanguages.map(item => (
            <MenuItem
              key={item.language}
              disabled={translatingMessage}
              onClick={() => handleSelectTranslateLanguage(item.language)}
            >
              {item.label}
            </MenuItem>
          )
        )}
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;

